const Clickable = function(){

	const run = () => {
		this.$body = $('body');
		this.$clickable = this.$body.find('.js-clickable');

		this.$clickable.addClass('cursor--pointer');

		this.$clickable.on('click', (e) => {
			const linkElement = e.currentTarget.querySelector('.js-link, a');
			const link = linkElement?.getAttribute('href');
			if (link) {
				e.preventDefault();
				nav.change(link);
			}
		});
	}

	this.run = () => run();
}